import { render } from "./GerarNovaTransportadora.vue?vue&type=template&id=da8e108a"
import script from "./GerarNovaTransportadora.vue?vue&type=script&lang=js"
export * from "./GerarNovaTransportadora.vue?vue&type=script&lang=js"

import "./GerarNovaTransportadora.vue?vue&type=style&index=0&id=da8e108a&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__